/**
 * Price modifier configuration for rental products
 * @module config/pricemodifiers
 */

/**
 * Calculates the long-term rental discount multiplier based on the number of days
 * @param {number} daysCount - The number of rental days
 * @returns {number} The discount multiplier (1.0 for no discount, 0.85 for 3+ days, 0.8 for 10+ days)
 */
export function longTermMultiplier(daysCount) {
  if (daysCount >= 10) {
    return 0.8;
  }
  if (daysCount >= 3) {
    return 0.85;
  }
  return 1.0;
}

/**
 * Default price modifiers
 */
export const defaultModifiers = {
  VAT_RATE: 1.27,
  MIN_RENTAL_DAYS: 1,
  LONG_TERM_THRESHOLD: 3,
  LONG_TERM_DISCOUNT: 0.85,
  EXTENDED_TERM_THRESHOLD: 10,
  EXTENDED_TERM_DISCOUNT: 0.8
};
